export {};

String.prototype.ljust = function (length: number, char = " ") {
  return this.length >= length ? this.toString() : this + char.repeat(length - this.length);
};

String.prototype.rjust = function (length: number, char = " "): string {
  return this.length >= length ? this.toString() : char.repeat(length - this.length) + this;
};
